import { FC, useEffect } from "react";
import Text from "@src/lib/ui/Text";

import { useRouter } from "next/router";
import { useTracking } from "@src/features/app/hooks/useTracking";
import { Button } from "@src/lib/ui/Button";
import Spacer from "@src/lib/ui/Spacer";

type Props = {
  title?: string;
  description?: string;
};

const NotFound: FC<Props> = ({ description, title }) => {
  const { trackEvent } = useTracking();
  const router = useRouter();
  useEffect(() => {
    trackEvent("404", {
      asPath: router.asPath,
      pathname: router.pathname,
      query: router.query,
      route: router.route,
    });
  }, [router, trackEvent]);
  return (
    <div className="flex flex-1 flex-col items-center justify-center self-stretch bg-white">
      <h1 style={{ fontSize: 64, marginBottom: 0 }}>{title || "404"}</h1>
      <Text variant="body-title">{description || "Page not found"}</Text>
      <Spacer size={64} />
      <Button size="lg" onClick={() => router.push("/")}>
        Go to home page
      </Button>
    </div>
  );
};

export default NotFound;
